import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7af7ba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Встречи", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Неправильный логин или пароль ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_a_typography_text, {
          key: 0,
          type: "danger"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_4,
    _createVNode(_component_a_form, {
      model: _ctx.formState,
      name: "basic",
      "label-col": { span: 8 },
      "wrapper-col": { span: 16 },
      autocomplete: "off",
      onFinish: _ctx.onFinish,
      onFinishFailed: _ctx.onFinishFailed
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: "Username",
          name: "username",
          rules: [{ required: true, message: 'Please input your username!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formState.username,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.username) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "Password",
          name: "password",
          rules: [{ required: true, message: 'Please input your password!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              value: _ctx.formState.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.password) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { "wrapper-col": { offset: 8, span: 16 } }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "onFinish", "onFinishFailed"])
  ]))
}